module.exports = __webpack_public_path__ + "static/img/one.7a1626e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/infoService/15/one.png
// module id = RUn4
// module chunks = 1